import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getStatusTag } from "../common/commonFunctions";
import CustomLoader from "../components/CustomLoader";
import AlertMsg from "../dialogBoxes/AlertMsg";
import SingleInternshipModal from "../modals/SingleInternshipModal";
import { getAllApplications, updateApplicationState } from "../services/employerAllPost";
import { CustomAlert, showToastAlert } from "./components/CustomAlert";
import DataTable from "./components/DataTable";

const AdminPostApplications = () => {
    const [loaderOpen, setLoaderOpen] = React.useState(true);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [apiData, setApiData] = React.useState([]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const [showOptions, setShowOptions] = useState("Approve");
    const [selectedOptions, setSelectedOptions] = useState(new Map());
    const [showAlert, setShowAlert] = useState(false);
    const [showReasonPopup, setShowReasonPopup] = useState(false);
    const [reason, setReason] = useState("");
    const [currPostId, setCurrPostId] = React.useState("");
    const admin = useSelector((state) => state.admin);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { state } = useParams();
    // Access the specific search key value
    let searchKeyValue = state;
    if (searchKeyValue == undefined) {
        searchKeyValue = "all";
    }

    const { id } = useParams();


    const tableColumns = [
        {
            field: "title",
            headerName: "Post Title",
            flex: 1,
            editable: false,
            renderCell: (params) => (
                <p>{params.row?.postId?.title}</p>
            ),
        },
        {
            field: "CName",
            headerName: "Company Name",
            flex: 1,
            editable: false,
            renderCell: (params) => (
                <p>{params.row?.postId?.cName}</p>
            ),
        },
        {
            field: "Student Name",
            headerName: "name",
            flex: 1,
            editable: false,
            renderCell: (params) => (
                <p>{params.row?.userId?.name}/{params.row?.userId?.email}</p>
            ),
        },
        {
            field: "createdAt",
            headerName: "Applied At",
            flex: 1,
            editable: false,
            valueGetter: (value) => {
                const date = new Date(value);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
                const day = String(date.getDate()).padStart(2, "0");

                return `${day}-${month}-${year}`;
            },
        },
        {
            field: "status",
            headerName: "STATUS",
            flex: 1,
            renderCell: (params) => (
                <Select
                    className="status-selectbox"
                    value={params.row?.state}
                    onChange={(event) => {
                        const newValue = event.target.value;
                        handleOptionChange(params.row._id, newValue);
                        params.api.updateRows([{ ...params.row, state: newValue }]);
                    }}
                >
                    {applicationOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {getStatusTag(option)}
                        </MenuItem>
                    ))}
                </Select>
            ),
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1,
            minWidth: 230,
            editable: false,
            renderCell: (params) => (
                <div>
                    <Button
                        className="circular-btn me-2"
                        variant="contained"
                        color="primary"
                        size="medium"
                        onClick={() => handleApplicationStateUpdate(params)}
                    >
                        Update
                    </Button>
                    <Tooltip title="Show Post Details">
                        <Button
                            variant="outlined"
                            onClick={() => handlePostView(params)}
                            className="circular-btn me-2"
                            startIcon={<RemoveRedEyeRoundedIcon />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    useEffect(() => {
        getApplications();
    }, [admin]);

    const getApplications = async () => {
        try {
            setLoaderOpen(true);
            const response = await getAllApplications(admin.token);
            setLoaderOpen(false);

            if (response.status !== 200) {
                showToastAlert("Application fetch failed", "error");
                return;
            }
            setApiData(response.data.applications);
            //set initial post status array 
            //let tempStatusMap = new Map();
            /*
            data.posts.map((item, stIndex) => {
                tempStatusMap.set(item._id, item.status);
            })
            setSelectedOptions(tempStatusMap);*/
        }
        catch (err) {
            throw new Error(err)
        }
    }
    const handleUpdate = (params) => {
        const id = params.row._id;
        const status = params.row.status;
        // Call your update function here with the row ID and status value
        //UpdateEmployerState(admin.token, id, status);
        console.log(`Updating row with ID: ${id}, Status: ${status}`);
        // Your update logic here
    };
    const handlePostView = (params) => {
        const id = params.row._id;
        setCurrPostId(id);
        setModalOpen(true);
    };

    const editPostView = (params) => {
        const id = params.row._id;
        navigate(`/admin/post/edit/${id}`);
    };

    const closePostView = () => {
        setModalOpen(false);
    }

    const applicationOptions = ["pending", "rejected", "shortlist", "hired", "reported"]; //live is just approved with live condition
    const handleOptionChange = (rowIndex, value) => {
        setSelectedOptions((prevValues) => {
            const tempValues = new Map(prevValues);
            tempValues.set(rowIndex, value);
            return tempValues;
        })
    }

    const handleClose = () => {
        setShowAlert(false);
    }

    const handleApplicationStateUpdate = async (params) => {
        const appid = params.row._id;
        setSelectedId(appid);
        const curSelOption = selectedOptions.get(appid)
        if (curSelOption === searchKeyValue) //do nothing 
            return;

        const response = await updateApplicationState(appid, curSelOption, admin.token);
        if (response.status !== 200) {
            showToastAlert(response.data.message, "error");
            return;
        }
        showToastAlert("status updated", "success");
    }

    return (
        <div>
            <h1 className="page-title-1 my-3 asdsd">Employer Posts</h1>
            {showAlert && (
                <AlertMsg
                    open={showAlert}
                    onClose={handleClose}
                    title="Success"
                    message="The operation was successful."
                    severity="success"
                    buttonText="Close"
                />
            )}
            <CustomAlert />
            <CustomLoader setLoaderOpen={setLoaderOpen} loaderOpen={loaderOpen} />
            <DataTable data={apiData} columns={tableColumns} id="_id" />
            <SingleInternshipModal open={modalOpen} postid={currPostId} closePostView={closePostView} />
        </div>
    );
};

export default AdminPostApplications;
